import React from "react";

import styles from "./ChargeOptionButton.module.scss";
import cls from "classnames";
import { Signal } from "@preact/signals-react";
import { ChargeOption } from "./ChargeYourCustomersBloc";

export interface Props {
  selected: Signal<ChargeOption>;
  option: ChargeOption;
  onClicked: (option: ChargeOption) => void;
}

export function ChargeOptionButton(props: Props) {
  function getDesc(): string {
    switch (props.option) {
      case ChargeOption.FREE:
        return "Users can use your app for free.";
      case ChargeOption.SUBSCRIPTION:
        return "Charge a monthly fee.";
    }
  }

  function isSelected(): boolean {
    return props.selected.value === props.option;
  }

  return (
    <div
      className={cls(styles.container, isSelected() ? styles.containerSelected : styles.containerUnselected)}
      onClick={() => props.onClicked(props.option)}
    >
      <div className={cls(styles.title, isSelected() ? styles.titleSelected : styles.titleUnselected)}>
        {props.option}
      </div>
      <div className={cls(styles.desc, isSelected() ? styles.descSelected : styles.descUnselected)}>{getDesc()}</div>
    </div>
  );
}
